import { render, staticRenderFns } from "./TokenLockView.vue?vue&type=template&id=028c838e&scoped=true&"
import script from "./TokenLockView.vue?vue&type=script&lang=ts&"
export * from "./TokenLockView.vue?vue&type=script&lang=ts&"
import style0 from "./TokenLockView.vue?vue&type=style&index=0&id=028c838e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028c838e",
  null
  
)

export default component.exports